import Client from './Client'
import User from './User'
import Status from './Status'

export default class Project
{
    constructor() {
      this.name = ''
      this.start = ''
      this.end = ''
      this.brief = ''
      this.connection_id = ''
      this.connection = new Client
      this.client_user = new User
      this.user = new User
      this.reviewed_by = new User
      this.status = new Status
      this.client_user_id = ''
      this.tasks = []
      this.collaborators = []
      this.brief_amendments = []
      this.milestones = []
      this.storage_used = 0
      this.type = 'connection'
      this.todo_counts = {
        completed: 0,
        total: 0
      }
      this.declined_at = null
    }
}
